// extracted by mini-css-extract-plugin
export default {"herotag":"herosection_herotag__ZPk4c","image":"herosection_image__S2PYn","heroDiv":"herosection_heroDiv__piomT"};